import React from 'react';

export const RuInundationModal = {
  title: 'Horizontal Inundation (meters)',
  body: (
    <div>
      <p>
        The maximum horizontal distance of inland flooding (in meters).
      </p>
    </div>
  ),
};
